<template>
  <div>
    <md-card>
      <md-card-content>
        <md-tabs class="md-secondary" md-alignment="centered">
          <md-tab md-label="Capacity Rules">
            <CapacityRuleTable />
          </md-tab>
          <md-tab md-label="Hem Living Expense">
            <HemLivingExpense />
          </md-tab>
        </md-tabs>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import CapacityRuleTable from "./AdministrateCapacityRulesTable.vue";
import HemLivingExpense from "./AdministrateHemLivingExpense.vue";

export default {
  components: {
    CapacityRuleTable,
    HemLivingExpense,
  },
};
</script>
